module.exports = __webpack_public_path__ + "static/Nomis-b0dc7615c8e86a4d5a0ce508dd299d9c.jpg";